import blogImg1 from "../../../images/blog/img-1.jpg";
import blogImg2 from "../../../images/blog/img-2.jpg";
import blogImg3 from "../../../images/blog/img-3.jpg";

import blogSingleImg1 from "../../../images/blog/img-4.jpg";
import blogSingleImg2 from "../../../images/blog/img-5.jpg";
import blogSingleImg3 from "../../../images/blog/img-6.jpg";


export const dataSampe = [{
  id: 1,
  title: 'Sampel Artikel 1',
  sort_description: 'Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan.',
  description: [{
    content: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    class: 'format-standart-content',
  }, {
    content: `The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.`,
    class: 'format-quote',
  }, {
    content: `Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.`,
    class: 'format-standart-content',
  }, {
    content: [{
      photo_link: 'https://photographylife.com/wp-content/uploads/2014/06/Nikon-D810-Image-Sample-6.jpg',
      weight: '500',
      height: '300',
      align: 'center',
    }, {
      photo_link: 'https://photographylife.com/wp-content/uploads/2014/06/Nikon-D810-Image-Sample-6.jpg',
      weight: '500',
      height: '300',
      align: 'center',
    }, {
      photo_link: 'https://photographylife.com/wp-content/uploads/2014/06/Nikon-D810-Image-Sample-6.jpg',
      weight: '500',
      height: '300',
      align: 'center',
    }],
    class: 'format-image',
  }],
  image_link: blogSingleImg1,
  total_comments: '30',
  createAt: '25 Sep 2021',
  writer: 'Hamba Allah',
  writer_description: `It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.`,
  blClass:'format-standard-image',
}, {
  id: 2,
  title: 'Sampel Artikel 1',
  sort_description: 'Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan.',
  description: [{
    content: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    class: 'format-standart-content',
  }, {
    content: `The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.`,
    class: 'format-quote',
  }, {
    content: `Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.`,
    class: 'format-standart-content',
  }, {
    content: [{
      photo_link: 'https://photographylife.com/wp-content/uploads/2014/06/Nikon-D810-Image-Sample-6.jpg',
      weight: '500',
      height: '300',
      align: 'center',
    }, {
      photo_link: 'https://photographylife.com/wp-content/uploads/2014/06/Nikon-D810-Image-Sample-6.jpg',
      weight: '500',
      height: '300',
      align: 'center',
    }, {
      photo_link: 'https://photographylife.com/wp-content/uploads/2014/06/Nikon-D810-Image-Sample-6.jpg',
      weight: '500',
      height: '300',
      align: 'center',
    }],
    class: 'format-image',
  }],
  image_link: blogSingleImg1,
  total_comments: '30',
  createAt: '25 Sep 2021',
  writer: 'Hamba Allah',
  writer_description: `It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.`,
  blClass:'format-standard-image',
}, {
  id: 3,
  title: 'Sampel Artikel 1',
  sort_description: 'Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan.',
  description: [{
    content: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    class: 'format-standart-content',
  }, {
    content: `The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.`,
    class: 'format-quote',
  }, {
    content: `Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.`,
    class: 'format-standart-content',
  }, {
    content: [{
      photo_link: 'https://photographylife.com/wp-content/uploads/2014/06/Nikon-D810-Image-Sample-6.jpg',
      weight: '500',
      height: '300',
      align: 'center',
    }, {
      photo_link: 'https://photographylife.com/wp-content/uploads/2014/06/Nikon-D810-Image-Sample-6.jpg',
      weight: '500',
      height: '300',
      align: 'center',
    }, {
      photo_link: 'https://photographylife.com/wp-content/uploads/2014/06/Nikon-D810-Image-Sample-6.jpg',
      weight: '500',
      height: '300',
      align: 'center',
    }],
    class: 'format-image',
  }],
  image_link: blogSingleImg1,
  total_comments: '30',
  createAt: '25 Sep 2021',
  writer: 'Hamba Allah',
  writer_description: `It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.`,
  blClass:'format-standard-image',
}, {
  id: 4,
  title: 'Sampel Artikel 1',
  sort_description: 'Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan.',
  description: [{
    content: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    class: 'format-standart-content',
  }, {
    content: `The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.`,
    class: 'format-quote',
  }, {
    content: `Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.`,
    class: 'format-standart-content',
  }, {
    content: [{
      photo_link: 'https://photographylife.com/wp-content/uploads/2014/06/Nikon-D810-Image-Sample-6.jpg',
      weight: '500',
      height: '300',
      align: 'center',
    }, {
      photo_link: 'https://photographylife.com/wp-content/uploads/2014/06/Nikon-D810-Image-Sample-6.jpg',
      weight: '500',
      height: '300',
      align: 'center',
    }, {
      photo_link: 'https://photographylife.com/wp-content/uploads/2014/06/Nikon-D810-Image-Sample-6.jpg',
      weight: '500',
      height: '300',
      align: 'center',
    }],
    class: 'format-image',
  }],
  image_link: blogSingleImg1,
  total_comments: '30',
  createAt: '25 Sep 2021',
  writer: 'Hamba Allah',
  writer_description: `It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.`,
  blClass:'format-standard-image',
}, {
  id: 5,
  title: 'Sampel Artikel 1',
  sort_description: 'Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan.',
  description: [{
    content: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    class: 'format-standart-content',
  }, {
    content: `The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham.`,
    class: 'format-quote',
  }, {
    content: `Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.`,
    class: 'format-standart-content',
  }, {
    content: [{
      photo_link: 'https://photographylife.com/wp-content/uploads/2014/06/Nikon-D810-Image-Sample-6.jpg',
      weight: '500',
      height: '300',
      align: 'center',
    }, {
      photo_link: 'https://photographylife.com/wp-content/uploads/2014/06/Nikon-D810-Image-Sample-6.jpg',
      weight: '500',
      height: '300',
      align: 'center',
    }, {
      photo_link: 'https://photographylife.com/wp-content/uploads/2014/06/Nikon-D810-Image-Sample-6.jpg',
      weight: '500',
      height: '300',
      align: 'center',
    }],
    class: 'format-image',
  }],
  image_link: blogSingleImg1,
  total_comments: '30',
  createAt: '25 Sep 2021',
  writer: 'Hamba Allah',
  writer_description: `It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.`,
  blClass:'format-standard-image',
}]